module.exports = __webpack_public_path__ + "img/t-22525-015-400x600.470d0d10.jpg";